import { register } from './index';
import { getInstanceDefinition } from '../cardLookup';
import {
  drawCards, grantXp, grantTemporaryStrength, getEquippedWeaponIds,
} from '../effectHelpers';

register('basic-regular', {
  dungeon: [
    // "If equipped with a polearm, draw a card." - only legal/useful if this
    // Regular is currently equipped with a Weapon carrying the Polearm trait.
    {
      resolve: (state, { playerId, instanceId }) => {
        const player = state.players.find((p) => p.id === playerId);
        const weaponId = getEquippedWeaponIds(player, instanceId).find((id) => getInstanceDefinition(state, id).traits.includes('Polearm'));
        if (!weaponId) throw new Error('This Regular must be equipped with a polearm to use this ability.');
        return drawCards(state, playerId, 1);
      },
      isUsable: (state, { playerId, instanceId }) => {
        const player = state.players.find((p) => p.id === playerId);
        return getEquippedWeaponIds(player, instanceId).some((id) => getInstanceDefinition(state, id).traits.includes('Polearm'));
      },
    },
  ],
});

function thunderstoneShardCandidates(state, { playerId, instanceId }) {
  const player = state.players.find((p) => p.id === playerId);
  return player.hand.filter((id) => {
    const def = getInstanceDefinition(state, id);
    return id !== instanceId && def.strength !== undefined && def.strength !== null;
  });
}

register('basic-thunderstone-shard', {
  dungeon: [
    {
      // "One hero gains Strength +2." Defaults to the highest-Strength hero
      // present when no explicit choice is supplied.
      resolve: (state, { playerId, instanceId, choices }) => {
        const heroCandidates = thunderstoneShardCandidates(state, { playerId, instanceId });
        const targetId = choices?.heroInstanceId
          ?? heroCandidates.sort((a, b) => getInstanceDefinition(state, b).strength - getInstanceDefinition(state, a).strength)[0];
        if (!targetId) throw new Error('No hero present to gain Strength.');
        return grantTemporaryStrength(state, playerId, targetId, 2);
      },
      getCandidates: thunderstoneShardCandidates,
    },
  ],
  spoils: [
    { resolve: (state, { playerId }) => grantXp(state, playerId, 1) },
  ],
});
